import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { aiApi } from '../api';

const nav = {
  display: 'flex', gap: 4, padding: '0 24px', background: '#1e293b',
  borderBottom: '1px solid #334155', alignItems: 'center', height: 56, flexWrap: 'nowrap', overflowX: 'auto',
};
const base = { color: '#64748b', fontWeight: 500, fontSize: 13, padding: '4px 10px', borderRadius: 6, textDecoration: 'none', whiteSpace: 'nowrap' };
const active = { ...base, color: '#38bdf8', background: '#0f2a3f' };

const LINKS = [
  { to: '/', label: 'Painel' },
  { to: '/bots', label: '🤖 Bots' },
  { to: '/backtest', label: '⏱ Backtest' },
  { to: '/models', label: '📊 Modelos & Dados' },
  { to: '/futures', label: '⚡ Futuros' },
];

export default function Layout() {
  const { data: alerts } = useQuery({
    queryKey: ['nav-alerts'],
    queryFn: () => aiApi.get('/signals/watch?threshold=0.68').then(r => r.data),
    refetchInterval: 60_000,
    staleTime: 55_000,
  });
  const alertCount = alerts?.count || 0;

  return (
    <>
      <nav style={nav}>
        <span style={{ fontWeight: 800, color: '#38bdf8', marginRight: 12, fontSize: 15, flexShrink: 0 }}>Trading AI</span>
        {LINKS.map(({ to, label }) => (
          <NavLink key={to} to={to} end={to === '/'} style={({ isActive }) => isActive ? active : base}>
            {label}
            {to === '/models' && alertCount > 0 && (
              <span style={{
                marginLeft: 4, background: '#fbbf24', color: '#0f172a',
                borderRadius: 10, padding: '1px 5px', fontSize: 10, fontWeight: 800,
              }}>{alertCount}</span>
            )}
          </NavLink>
        ))}
      </nav>
      <main style={{ padding: '24px 28px', maxWidth: 1400, margin: '0 auto' }}>
        <Outlet />
      </main>
    </>
  );
}
